import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = (weeks = []) => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'activity',
      label: i18n.t('common_words.activity'),
      minWidth: 250,
      align: 'left',
      sortable: true,
      fixed: true,
    },
    {
      prop: 'lots',
      label: i18n.t('common_words.allotment(s)'),
      minWidth: 140,
      align: 'left',
      sortable: true,
      fixed: true,
      formatter: (row) =>
        Array.isArray(row.lots) ? row.lots.join(', ') : row.lots,
    },
  ];

  if (weeks) {
    Table.tableColumns.push(
      ...weeks.map((week) => ({
        label: `${week}`,
        align: 'center',
        children: [
          {
            prop: `weeks.${week}.planned_quantity`,
            label: 'P',
            minWidth: 60,
            align: 'center',
          },
          {
            prop: `weeks.${week}.executed_quantity`,
            label: 'E',
            minWidth: 60,
            align: 'center',
          },
          {
            prop: `weeks.${week}.completion_rate_formatted`,
            label: '%',
            minWidth: 80,
            align: 'center',
          },
        ],
      }))
    );
  }

  const Search = { ...Tables.Search };
  return { Table, Search };
};

export default configTable;
